'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import ReadyToBeShippedIcon from './ReadyToBeShippedIcon';
import InDeliveryIcon from './InDeliveryIcon';
import DeliveredIcon from './DeliveredIcon';
import TrackingStatusItem from './TrackingStatusItem/TrackingStatusItem';

export function TrackingStatus({
  status,
  deliveredAsShipped = false,
}: Readonly<{
  // 'ready' | 'shipped' | 'delivered'; any other value renders no step as active
  status: string;
  // deliveredAsShipped - in case the option is true delivered will be 'shipped'
  // also delivered item will be hidden
  deliveredAsShipped?: boolean;
}>) {
  // Use OrderDetails context for backward compatibility
  const t = useTranslations('TrackingStatus');

  const readyActive = ['ready', 'shipped', 'delivered'].includes(status);
  const shippedActive = ['shipped', 'delivered'].includes(status);
  const deliveredActive = ['delivered'].includes(status);

  const widthClass = 'sm:w-1/2';

  return (
    <div className="relative">
      <div className="flex flex-col text-center text-md text-neutral-50 sm:flex-row">
        <TrackingStatusItem
          Icon={ReadyToBeShippedIcon}
          label={t('Ready to be shipped')}
          isActive={readyActive}
          className={widthClass}
        />
        <div className="m-3 my-1 ml-5 h-4 w-px bg-neutral-15 sm:hidden" />
        <TrackingStatusItem
          Icon={InDeliveryIcon}
          label={t('Shipped')}
          isActive={shippedActive}
          className={widthClass}
        />
        {!deliveredAsShipped && (
          <>
            <div className="my-1 ml-5 h-4 w-px bg-neutral-15 sm:hidden" />
            <TrackingStatusItem
              Icon={DeliveredIcon}
              label={t('Delivered')}
              isActive={deliveredActive}
              className={widthClass}
            />
          </>
        )}
      </div>

      {deliveredAsShipped ? (
        <div className="absolute left-[calc(17.5%+30px)] right-[calc(17.5%+30px)] top-7 hidden h-px bg-neutral-15 sm:block" />
      ) : (
        <>
          <div className="absolute left-[calc(16.5%+30px)] right-[calc(50%+30px)] top-7 hidden h-px bg-neutral-15 sm:block" />
          <div className="absolute left-[calc(50%+30px)] right-[calc(16.5%+30px)] top-7 hidden h-px bg-neutral-15 sm:block" />
        </>
      )}
    </div>
  );
}
